import { useEffect, useState } from 'react';
import { NotFound } from '../../../components/NotFound';
import { useAuth } from '../../../contexts/AuthProvider';
import { numberDisplay } from '../../../services/formats';
import { PageContainer } from '../../../components/PageContainer';
import { Table } from 'react-bootstrap';
import { useUtility } from '../../../contexts/UtilityContext';
import { fetchRptPoPiItemBalance, RptPurchaseOrderItemBalanceModel } from '../../../model/purchase-order.model';
import { Modal } from '../../../components/Modal';
import ItemPurchaseOrderBalance from './rpt-item-po-pi-balance';

export default function PurchaseOrderItemBalance() {
  const { isLoading, showLoader, hideLoader } = useUtility();
  const [list, setList] = useState<Array<RptPurchaseOrderItemBalanceModel>>([]);
  const [selectedItem, setSelectedItem] = useState<RptPurchaseOrderItemBalanceModel>();
  const { authInfo } = useAuth();

  useEffect(() => {
    async function fetchData() {
      try {
        showLoader();
        const res = await fetchRptPoPiItemBalance(authInfo);
        setList(res);
      } catch (err) {
        console.error(err);
      } finally {
        hideLoader();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo]);

  return (
    <>
      <PageContainer
        title="Purchase Order Item Balance"
        body={!isLoading && list.length === 0 ? <NotFound /> :
          <Table striped bordered hover responsive width="100%">
            <thead>
              <tr>
                <th className='text-start'>ITEM</th>
                <th className='text-end'>ORDER</th>
                <th className='text-end'>RECD</th>
                <th className='text-end'>BALANCE</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={`po-pi-item-${index}`} onClick={() => setSelectedItem(item)}>
                  <td className='text-start'>{item.item_name}</td>
                  <td className='text-end'>{numberDisplay(item.ordered_qty)}</td>
                  <td className='text-end'>{numberDisplay(item.recd_qty)}</td>
                  <td className='text-end'>{numberDisplay(item.ordered_qty - item.recd_qty)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        }
      />
      <Modal
        title={selectedItem?.item_name ?? "Item's Pending Orders"}
        show={!!selectedItem}
        handleClose={() => setSelectedItem(undefined)}
      >
        <ItemPurchaseOrderBalance id={selectedItem?.item_id} />
      </Modal>
    </>
  );
};